<!--
Ok diciture
-->

<template>
  <div class="login">
    <br />
    <Header></Header>
    <br />
    <b-row>
      <!--  colonna testo promo -->
      <b-col sm="12" md="8" lg="8">
        <b-row>
          <b-col cols="12">
            <p>
              <strong
                >Sei titolare di un hotel, un resort o altro tipo di struttura
                ricettiva ?</strong
              >
              <br />Puoi dare ai tuoi clienti la possibilità di inserire online
              i loro dati personali ed avere tali dati inseriti automaticamente
              all'interno del tuo gestionale.
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <p>
              Fai conoscere
              <NomeSitoPiccolo />&nbsp; al fornitore del tuo gestionale. Lui
              potrà facilmente integrarlo nel suo software e darti la
              possibilità di risparmiare tempo nella gestione delle
              prenotazioni.
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-button
              style="width: 100%"
              variant="success"
              v-on:click="desidero_piu_informazioni_struttura"
              >{{ labels.desidero_piu_informazioni }}</b-button
            >
          </b-col>
        </b-row>
        <br />
        <br />
        <br />

        <b-row>
          <b-col cols="12">
            <p>
              <strong
                >Sei proprietario di un software per la gestione di hotel,
                resort e altri tipi di strutture ricettive ?</strong
              >
              <br />Vuoi offrire ai tuoi clienti il servizio di check-in online
              integrato nel tuo software gestionale ? <br />Contattaci per
              sapere come integrare facilmente <NomeSitoPiccolo />&nbsp;nel tuo
              gestionale.
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-button
              style="width: 100%"
              variant="success"
              v-on:click="desidero_piu_informazioni_partner"
              >{{ labels.desidero_piu_informazioni }}</b-button
            >
          </b-col>
        </b-row>
      </b-col>

      <!-- colonna login -->
      <b-col sm="12" md="4" lg="4">
        <div class="corpo-login">
          <b-row>
            <b-col
              cols="12"
              style="
                text-align: center;
                color: orange;
                font-size: 2.5em;
                font-weight: normal;
              "
              >{{ labels.accedi }}</b-col
            >
            <br />
            <br />
            <br />
          </b-row>
          <b-form-row class="b-form-row">
            <b-col cols="12">
              <b-form-group class="b-form-group" v-bind:label="labels.utente">
                <b-form-input
                  :size="size"
                  class="b-form-input"
                  :id="utente"
                  v-model="utente"
                  maxlength="45"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row class="b-form-row">
            <b-col cols="12">
              <b-form-group class="b-form-group" v-bind:label="labels.password">
                <b-form-input
                  :size="size"
                  class="b-form-input"
                  :id="password"
                  v-model="password"
                  maxlength="45"
                  type="password"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-row>
            <b-col cols="12">
              <br />
              <b-button
                style="width: 100%"
                variant="success"
                v-on:click="accedi"
                :disabled="invio_in_corso"
                >{{ labels.accedi }}</b-button
              >
              <div style="text-align: right">
                <b-link v-on:click="password_dimenticata">{{
                  labels.password_dimenticata
                }}</b-link>
                <p></p>
              </div>
            </b-col>
          </b-row>

          <b-row style="text-align: center" class="errore" v-if="errore != ''">
            <b-col cols="12">
              {{ labels_errori[errore] }}
              <br />
              <br />
            </b-col>
          </b-row>

          <b-row>
            <br />
            <br />
            <br />
            <b-col cols="12">
              {{ labels.se_non_hai_un_account }}
              <b-link @click="registrati">{{ labels.registrati }}</b-link
              >.
            </b-col>
            <br />
            <br />
          </b-row>
        </div>
      </b-col>
    </b-row>

    <br />
    <br />
    <div class="hidden-xs alert alert-success">
      <NomeSitoPiccolo />&nbsp;è un prodotto
      <a class="alert-link" href="http://loquos.it" target="_blank">Loquos</a>
      <b-link
        style="float: right; color: black; margin-top: 11px; font-weight: bold"
        @click="VaiAPrivacy"
        >Privacy</b-link
      >
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import NomeSitoPiccolo from "@/components/NomeSitoPiccolo.vue";
const axios = require("axios");

export default {
  name: "Login",
  components: {
    Header,
    NomeSitoPiccolo,
  },
  data() {
    return {
      file: null,
      file2: null,
      url: "",
      labels: {},
      labels_errori: {},
      struttura: "",
      utente: "",
      password: "",
      size: "sm",
      errore: "",
      invio_in_corso: false,
    };
  },
  methods: {
    accedi() {
      try {
        let me = this;
        let parametri = {
          utente: this.utente,
          password: this.password,
        };

        let ServerURL = this.$store.state.ServerURL;
        let parametri_json = JSON.stringify(parametri);
        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "POST",
          url: ServerURL + "CheckIn/ControllaCredenziali",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              me.$store.commit("SettaUtenteAutenticato", true);
              if (response.data.oggetto.select_utente.ruolo == "P") {
                me.$store.commit("SettaPartner", true);
                me.$store.commit("SettaAmministratore", true);
              } else if (response.data.oggetto.select_utente.ruolo == "A") {
                me.$store.commit("SettaPartner", false);
                me.$store.commit("SettaAmministratore", true);
              } else {
                me.$store.commit("SettaPartner", false);
                me.$store.commit("SettaAmministratore", false);
              }
              me.$store.commit(
                "SettaUtente",
                response.data.oggetto.select_utente.codice
              );
              me.$store.commit("SettaPassword", me.password);
              me.$store.commit(
                "SettaStruttura",
                response.data.oggetto.select_utente.struttura
              );
              me.$store.commit(
                "SettaDescrizioneStruttura",
                response.data.oggetto.descrizione_struttura
              );
              me.$store.commit(
                "SettaLingua",
                response.data.oggetto.select_utente.lingua
              );

              if (me.$store.state.PathToLoadAfterLogin != "") {
                const pathToLoad = JSON.parse(
                  me.$store.state.PathToLoadAfterLogin
                );

                me.$store.commit("SettaPathToLoadAfterLogin", "");

                me.$router.push({
                  path: pathToLoad.path,
                  params: pathToLoad.params,
                  query: pathToLoad.query,
                });
              } else {
                me.errore = "";
                if (response.data.oggetto.select_utente.ruolo == "P") {
                  me.$router.push("/menupartner");
                } else {
                  me.$router.push("/amministrazione");
                }
              }
            } else if (response.data.errore == -2) {
              me.registraErrore(response.data.esito, "Login-accedi");
            } else {
              me.errore = response.data.esito;
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "Login-accedi");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "Login-accedi");
      }
    },
    registrati() {
      try {
        this.$router.push("/registrati");
      } catch (error) {
        this.registraErrore(error, "Login-registrati");
      }
    },
    desidero_piu_informazioni_struttura() {
      try {
        this.$router.push("/home/piuinformazionistruttura");
      } catch (error) {
        this.registraErrore(error, "Login-desidero_piu_informazioni_struttura");
      }
    },
    desidero_piu_informazioni_partner() {
      try {
        this.$router.push("/home/piuinformazionipartner");
      } catch (error) {
        this.registraErrore(error, "Login-desidero_piu_informazioni_partner");
      }
    },
    password_dimenticata() {
      try {
        this.$router.push({
          name: "ResettaPassword",
          params: { utente: this.utente },
        });
      } catch (error) {
        this.registraErrore(error, "Login-password_dimenticata");
      }
    },
    VaiAPrivacy() {
      let routeData = this.$router.resolve({
        name: "InformativaSito",
      });
      window.open(routeData.href, "_blank");
    },
  },
  created() {
    try {
      this.url = this.$store.state.ServerURL;
      fn_CambiaLingua(this.$store.state.Lingua, this);

      this.utente == "";
      this.password = "";
      this.$store.commit("SettaUtenteAutenticato", false);
      this.$store.commit("SettaPartner", false);
      this.$store.commit("SettaAmministratore", false);
      this.$store.commit("SettaUtente", "");
      this.$store.commit("SettaPassword", "");
      this.$store.commit("SettaStruttura", "");
    } catch (error) {
      this.registraErrore(error, "Login-created");
    }
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      inserisci_i_valori_richiesti:
        "Inserisci i valori richiesti per entrare nel pannello di amministrazione",
      accedi: "Accedi",
      utente: "Utente",
      password: "Password",
      password_dimenticata: "Password dimenticata ?",
      se_non_hai_un_account: "Se non hai un account",
      registrati: "registrati",
      desidero_piu_informazioni: "Desidero avere più informazioni",
    };
    let labels_inglese = {
      inserisci_i_valori_richiesti:
        "Inserisci i valori richiesti per entrare nel pannello di amministrazione",
      accedi: "Accedi",
      utente: "Utente",
      password: "Password",
      password_dimenticata: "Password dimenticata ?",
      se_non_hai_un_account: "Se non hai un account",
      registrati: "registrati",
      desidero_piu_informazioni: "Desidero avere più informazioni",
    };
    let labels_tedesco = {
      inserisci_i_valori_richiesti:
        "Inserisci i valori richiesti per entrare nel pannello di amministrazione",
      accedi: "Accedi",
      utente: "Utente",
      password: "Password",
      password_dimenticata: "Password dimenticata ?",
      se_non_hai_un_account: "Se non hai un account",
      registrati: "registrati",
      desidero_piu_informazioni: "Desidero avere più informazioni",
    };
    let labels_francese = {
      inserisci_i_valori_richiesti:
        "Inserisci i valori richiesti per entrare nel pannello di amministrazione",
      accedi: "Accedi",
      utente: "Utente",
      password: "Password",
      password_dimenticata: "Password dimenticata ?",
      se_non_hai_un_account: "Se non hai un account",
      registrati: "registrati",
      desidero_piu_informazioni: "Desidero avere più informazioni",
    };

    let labels_errori_italiano = {
      credenziali_non_valide: "Utente o password errati",
      struttura_non_trovata: "La struttura dell'utente non è stata trovata.",
      struttura_non_attiva: "La struttura dell'utente non è attiva.",
      registrazione_non_completata:
        "La registrazione dell'utente non è stata completata.",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      credenziali_non_valide: "Utente o password errati",
      struttura_non_trovata: "La struttura dell'utente non è stata trovata.",
      struttura_non_attiva: "La struttura dell'utente non è attiva.",
      registrazione_non_completata:
        "La registrazione dell'utente non è stata completata.",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      credenziali_non_valide: "Utente o password errati",
      struttura_non_trovata: "La struttura dell'utente non è stata trovata.",
      struttura_non_attiva: "La struttura dell'utente non è attiva.",
      registrazione_non_completata:
        "La registrazione dell'utente non è stata completata.",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      credenziali_non_valide: "Utente o password errati",
      struttura_non_trovata: "La struttura dell'utente non è stata trovata.",
      struttura_non_attiva: "La struttura dell'utente non è attiva.",
      registrazione_non_completata:
        "La registrazione dell'utente non è stata completata.",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "Login-fn_CambiaLingua");
  }
}
function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>

<style scoped>
.login {
  text-align: justify;
}

.corpo-login {
  padding: 20px 40px 30px 40px;
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}
</style>
